import { Link } from '@tanstack/react-router';
import { ConditionalWrapper } from './ConditionalWrapper';
import { HeroIcon } from './HeroIcon';

interface BackButtonProps {
  title?: string;
  onClick?: () => void;
  href?: string;
}

export const BackButton = ({
  title,
  onClick = () => {
    history.back();
  },
  href,
}: BackButtonProps) => {
  const commonClasses =
    'flex cursor-pointer items-center gap-1.5 self-start border-b border-b-transparent text-zinc-800 hover:border-b-black hover:text-black';
  return (
    <ConditionalWrapper
      condition={Boolean(href)}
      falseWrapper={(children) => (
        <button
          className={commonClasses}
          onClick={onClick}
          title={title || 'Zurück'}
        >
          {children}
        </button>
      )}
      wrapper={(children) => (
        <Link to={href || '#'} className={commonClasses}>
          {children}
        </Link>
      )}
    >
      <>
        <HeroIcon
          variant="outline"
          name={'ArrowLeftCircle'}
          className="inline-block h-5 w-5 shrink-0"
        />
        {title || 'Zurück'}
      </>
    </ConditionalWrapper>
  );
};
